import React from "react";
import {
  ADMIN_GUIDE_SECTIONS,
  MONITOR_GUIDE_SECTIONS,
} from "../utils/quickGuide";

/**
 * Guía rápida de la app: paso a paso desplegable de lo que puede hacer un
 * monitor y, con `includeAdmin`, también el administrador. Se muestra en la
 * pestaña Monitor (monitores y admin) y en la pestaña Admin. Todo lo que
 * describe existe hoy en la interfaz; si cambia una pantalla, hay que
 * actualizar el texto en shared/utils/quickGuide.ts.
 */
interface Props {
  /** Añade las secciones de administración (roles, tickets, clases de otros). */
  includeAdmin?: boolean;
}

const QuickGuide: React.FC<Props> = ({ includeAdmin = false }) => {
  const sections = includeAdmin
    ? [...MONITOR_GUIDE_SECTIONS, ...ADMIN_GUIDE_SECTIONS]
    : MONITOR_GUIDE_SECTIONS;
  return (
    <details className="group rounded-xl border border-[#334155] bg-[#1e293b]">
      <summary className="cursor-pointer select-none list-none px-4 py-3 flex items-center justify-between gap-3">
        <span>
          <span className="text-white font-medium">
            {includeAdmin
              ? "Guía rápida de la app"
              : "Guía rápida para monitores"}
          </span>
          <span className="block text-[#94a3b8] text-xs mt-0.5">
            {includeAdmin
              ? "Paso a paso de rutinas, clases, socios, roles y peticiones"
              : "Paso a paso de rutinas, clases y acceso de los socios"}
          </span>
        </span>
        <span
          aria-hidden="true"
          className="text-[#94a3b8] transition-transform group-open:rotate-180"
        >
          ▾
        </span>
      </summary>

      <div className="px-4 pb-4 space-y-2 border-t border-[#334155] pt-3">
        {sections.map((section) => (
          <details key={section.id} className="rounded-lg bg-[#0f172a]/60">
            <summary className="cursor-pointer select-none list-none px-3 py-2 text-sm text-white">
              {section.title}
            </summary>
            <div className="px-3 pb-3 text-sm text-[#cbd5e1]">
              {section.intro && (
                <p className="text-[#94a3b8] text-xs mb-2">{section.intro}</p>
              )}
              <ol className="list-decimal pl-5 space-y-1.5">
                {section.steps.map((step, i) => (
                  <li key={i}>{step}</li>
                ))}
              </ol>
              {section.note && (
                <p className="mt-2 text-xs text-[#94a3b8] border-l-2 border-[#1f9e3f] pl-2">
                  {section.note}
                </p>
              )}
            </div>
          </details>
        ))}
      </div>
    </details>
  );
};

export default QuickGuide;
